<template>
  <fb-form-properties-manager :fields="fields" :formId="formId" />
</template>

<script>
export default {
  name: "FrequencyDurationV1Properties",
  props: ["formId"],
  data() {
    return {
      fields: [
        {
          type: "textInput",
          properties: {
            label: "Label"
          },
          property: "label"
        },
        {
          type: "multipleText",
          properties: {
            label: "Frequency First Options"
          },
          property: "frequencyFirstOptions"
        },
        {
          type: "multipleText",
          properties: {
            label: "Frequency Second Options"
          },
          property: "frequencySecondOptions"
        },
        {
          type: "multipleText",
          properties: {
            label: "Duration Options"
          },
          property: "durationOptions"
        },
        {
          type: "textInput",
          properties: {
            label: "Description"
          },
          property: "description"
        },
        {
          type: "checkbox",
          properties: {
            label: "Required"
          },
          property: "required"
        },
        {
          type: "checkbox",
          properties: {
            label: "Editable in Patient Portal"
          },
          property: "eFormEditable"
        },
        {
          type: "conditionEditor",
          properties: {
            label: "Visibility condition",
            updateValueMiddleware: (value) => {return value.replace("{{(","{{!(")}
          },
          property: "hidden"   
        }
      ]
    };
  }
};
</script>

<style></style>
